/**
 * Reveals side columns when this fraction of the section’s bounding box intersects the viewport (by area).
 * If the section is taller than the viewport, the ratio cannot reach this value — we use the max
 * achievable (viewport area overlap ÷ section area) so the animation still runs once it’s fully in view.
 */
(function () {
  const ROOT = '[data-comparison-reveal-root]';
  const SIDE = '.comparison-table__col--reveal-side';
  const PENDING_CLASS = 'comparison-table__col--reveal-pending';
  /** How much of the section must be visible (0–1). Lower = earlier column reveal as section enters. */
  var REVEAL_FRACTION = 0.36;

  function meetsRevealThreshold(entry) {
    var br = entry.boundingClientRect;
    if (br.height < 1) return false;
    var rootH = entry.rootBounds && entry.rootBounds.height ? entry.rootBounds.height : window.innerHeight;
    var r = entry.intersectionRatio;
    var required = Math.min(REVEAL_FRACTION, rootH / br.height);
    return r >= required - 0.002;
  }

  function buildThresholdList() {
    var list = [];
    var i = 0;
    for (; i <= 100; i += 1) {
      list.push(i / 100);
    }
    return list;
  }

  function revealColumns(tableRoot) {
    tableRoot.querySelectorAll(SIDE + '.' + PENDING_CLASS).forEach(function (el) {
      el.classList.remove(PENDING_CLASS);
    });
  }

  function revealInDesignMode(root) {
    if (typeof Shopify === 'undefined' || !Shopify.designMode) return;
    (root || document).querySelectorAll(SIDE + '.' + PENDING_CLASS).forEach(function (el) {
      el.classList.add('scroll-trigger--design-mode');
    });
  }

  function observeSection(root) {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      (root || document).querySelectorAll(ROOT).forEach(function (table) {
        revealColumns(table);
      });
      return;
    }

    var tables = (root || document).querySelectorAll(ROOT);
    if (!tables.length) return;

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!meetsRevealThreshold(entry)) return;
          revealColumns(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: buildThresholdList() }
    );

    tables.forEach(function (table) {
      if (!table.querySelector(SIDE + '.' + PENDING_CLASS)) return;
      io.observe(table);
    });

    scheduleColumnRevealSync();
  }

  var columnRevealScrollScheduled = false;
  function scheduleColumnRevealSync() {
    if (columnRevealScrollScheduled) return;
    columnRevealScrollScheduled = true;
    requestAnimationFrame(function () {
      columnRevealScrollScheduled = false;
      syncComparisonTableColumnsInView();
    });
  }

  function bindComparisonTableColumnScrollSync() {
    if (bindComparisonTableColumnScrollSync._done) return;
    bindComparisonTableColumnScrollSync._done = true;
    window.addEventListener('scroll', scheduleColumnRevealSync, { passive: true, capture: true });
    window.addEventListener('resize', scheduleColumnRevealSync, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', scheduleColumnRevealSync, { passive: true });
    }
  }
  bindComparisonTableColumnScrollSync();

  function init(root) {
    revealInDesignMode(root);
    observeSection(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector(ROOT)) {
      init(event.target);
    }
  });

  function syncComparisonTableColumnsInView() {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll(ROOT).forEach(function (table) {
      if (!table.querySelector(SIDE + '.' + PENDING_CLASS)) return;
      var br = table.getBoundingClientRect();
      if (br.height < 1) return;
      var vw = window.innerWidth || 0;
      var vh = window.innerHeight || 1;
      var interLeft = Math.max(br.left, 0);
      var interRight = Math.min(br.right, vw);
      var interTop = Math.max(br.top, 0);
      var interBottom = Math.min(br.bottom, vh);
      var w = Math.max(0, interRight - interLeft);
      var hVis = Math.max(0, interBottom - interTop);
      var elArea = br.width * br.height;
      var interArea = w * hVis;
      var r = elArea > 0 ? interArea / elArea : 0;
      var rootH = vh;
      var required = Math.min(REVEAL_FRACTION, rootH / br.height);
      if (r >= required - 0.002) {
        revealColumns(table);
      }
    });
  }

  if (window.r3nuRegisterViewportRecheck) {
    window.r3nuRegisterViewportRecheck(syncComparisonTableColumnsInView);
  }
})();
